import { Injectable, inject } from '@angular/core';
import { HttpClientService } from '@core/services/http-client.service';
import { Router } from '@angular/router';
import { VisionRequestAQuote } from '@core/models/VisionRequestAQuote';
import { FacilityMarketDto, FacilitySessionDto, SelectedFacilityDto, VisionRequestAQuoteDto } from '@core/models/dto/VisionRequestAQuoteModelDto';
import { VisionService } from '@booking/vision/services/vision.service';
import { JsonFormatterService } from '@booking/common/json-formatter.service';
import { tap } from 'rxjs';
import { MessageService } from '@core/services/message.service';
import { MessageType } from '@core/enums/MessageType.enum';


@Injectable({
  providedIn: 'root'
})
export class RequestAQuoteVisionService {
  private visionService = inject(VisionService);
  private httpClientService = inject(HttpClientService);
  private jsonFormmater = inject(JsonFormatterService);
  private router = inject(Router);
  private messageService = inject(MessageService);

  private mapObjectBeforeSending(requestQuoteForm: VisionRequestAQuote): VisionRequestAQuoteDto {
    const rawValue = requestQuoteForm.getRawValue();

    const facilityRespondentMarkets: FacilityMarketDto[] = rawValue.sessions.map((item: any) => {
      const selectedFacility: SelectedFacilityDto = {
        name: item.facility.facilityName || item.facility.locationName,
        address: item.facility.address,
        country: this.getCountry(item.facility.country),
        city: this.getCity(item.facility.city, item.facility.country)
      };

      const facilitySessions: FacilitySessionDto = {
        date: item.startDate,
        hoursStart: item.hoursStart === 'TBC' ? null : +item.hoursStart,
        hoursEnd: item.hoursEnd === 'TBC' ? null : +item.hoursEnd,
        minutesStart: item.minutesStart === 'TBC' ? null : +item.minutesStart,
        minutesEnd: item.minutesEnd === 'TBC' ? null : +item.minutesEnd,      
        highDefinition: rawValue.highDefinition,
        mobileStreaming: rawValue.mobileStreaming,
        locationListed: !item.facility.locationNotListed,
        facilityServiceTypeId: rawValue.serviceTypeId,
        selectedFacility: selectedFacility,
        multiLanguageAudioOptionId: item.language
      };

      return {
        ...(rawValue['humanTranscript']['transcript'] && {
          humanTranscript: {
            languageOptionId: rawValue['humanTranscript']['languageOptionId'],
            deliveryOptionId: rawValue['humanTranscript']['deliveryOptionId'],
          },
        }),
        requestAQuoteFacilitySessions: [facilitySessions]
      };
    });

    const res: VisionRequestAQuoteDto = {
      projectTopic: rawValue.projectTopic,
      coordinator: rawValue.coordinator,
      contactDetail: rawValue.contactDetail,
      usabilityStudy: rawValue.usabilityStudy,
      researchTypeId: rawValue.serviceTypeId,
      interviewTypeId: rawValue.interviewTypeId,
      requestAQuoteFacilityRespondentMarkets: facilityRespondentMarkets
    };

    return this.jsonFormmater.cleanData(res);
  }

  private getCountry(id: number): string | undefined {
    return this.visionService.getCountryById(id);
  }

  private getCity(cityId: number, countryId: number): string | undefined {
    return this.visionService.getCityById(cityId, countryId);
  }

  public save$(requestQuoteForm: VisionRequestAQuote) {
    const mappedObj = this.mapObjectBeforeSending(requestQuoteForm);
    return this.httpClientService.post(mappedObj, 'RequestAQuote/facility').pipe(
      tap(() => this.router.navigate(['/thank-you']))
    );
  }
}
